import axios from "axios";

import { isInPlayer } from "../../config/const";

const postLog = (data = { level: "debug", message: "", data: {} }) => {
  if (!isInPlayer) {
    return;
  }

  // console.log(`[postLog]: `, data);

  if (process.env.NODE_ENV === "development") {
    return;
  }

  axios
    .post("http://localhost:134/log", data, {
      headers: { "Content-Type": "application/json" },
    })
    .catch(console.log);
};

const Logger = {
  log: (message: string, data?: any) =>
    postLog({ level: "info", message, data }),
  info: (message: string, data?: any) =>
    postLog({ level: "info", message, data }),
  warn: (message: string, data?: any) =>
    postLog({ level: "warn", message, data }),
  debug: (message: string, data?: any) =>
    postLog({ level: "debug", message, data }),
  error: (message: string, data?: any) =>
    postLog({ level: "error", message, data }),
};

export default Logger;
